import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TransactionService {

  constructor(
    private http: HttpClient
  ) { }

  getTransactions(keyword: string = '', pageQuery: string = '') {
    return this.http.get(`${environment.API_BASE_URL_V3}/list-transaction-logs-by-id?search=${keyword}${pageQuery}`);
  }

  createTransaction(data: any, id: any = '') {
    if (id !== '') return firstValueFrom(this.http.post(`${environment.API_BASE_URL_V3}/create-transaction-log?id=${id}`, data));
    else return firstValueFrom(this.http.post(`${environment.API_BASE_URL_V3}/create-transaction-log`, data));
  }

  /**
   * Gets view transactions
   * @param {string} id 
   * @returns  
   */
  getViewTransactions() {
    return this.http.get(`${environment.API_BASE_URL_V3}/view-transaction-log`);
  }

  /**
   * Updates view transactions
   * @param {object} data 
   * @returns  
   */
  updateViewTransactions(data: object) {
    return this.http.post(`${environment.API_BASE_URL_V3}/view-transaction-log`, data);
  }

}
